/*
 * Adds the "Estimated ship date" line item property to any pre-order line that reached the cart
 * without it. The property is normally set by a hidden field in the product page's Add to Cart form
 * (snippets/product-buy-buttons.liquid). Anything that adds to the cart another way, such as the
 * Fast Bundle "Add bundle to cart" box on a product page, skips that field, so the order shows no date.
 *
 * Which products are pre-orders is read from /products/<handle>?view=preorder-date
 * (templates/product.preorder-date.liquid), so the date always comes from the same snippet the
 * buy button uses and a date that has passed is left off.
 *
 * Runs three ways: after any add to cart, once when a page loads with a non-empty cart, and just
 * before the cart form goes to checkout. A failure at any step leaves the cart exactly as it was.
 */
(function () {
  var PROP = 'Estimated ship date';
  var CACHE_KEY = 'bes-preorder-dates';
  var CACHE_MS = 30 * 60 * 1000;
  var origFetch = window.fetch;
  if (!origFetch || window.__besPreorderDateFix) return;
  window.__besPreorderDateFix = true;

  var cache = {};
  try {
    cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}') || {};
  } catch (e) {
    cache = {};
  }

  function saveCache() {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (e) {}
  }

  function shipDate(handle) {
    var hit = cache[handle];
    if (hit && Date.now() - hit.t < CACHE_MS) return Promise.resolve(hit.d);
    return origFetch('/products/' + encodeURIComponent(handle) + '?view=preorder-date', {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.ok ? r.json() : { date: '' };
      })
      .then(function (j) {
        var d = (j && j.date) || '';
        cache[handle] = { d: d, t: Date.now() };
        saveCache();
        return d;
      })
      .catch(function () {
        return '';
      });
  }

  function readCart() {
    return origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  // Stamps one line at a time, because a changed property changes the line's key and can merge lines.
  function fixCart() {
    var changed = false;
    function step(n) {
      if (n > 25) return Promise.resolve(changed);
      return readCart().then(function (cart) {
        var items = cart.items || [];
        function find(i) {
          if (i >= items.length) return Promise.resolve(null);
          var props = items[i].properties || {};
          if (props[PROP]) return find(i + 1);
          return shipDate(items[i].handle).then(function (d) {
            return d ? { line: i + 1, item: items[i], date: d } : find(i + 1);
          });
        }
        return find(0).then(function (hit) {
          if (!hit) return changed;
          var props = {};
          Object.keys(hit.item.properties || {}).forEach(function (k) {
            props[k] = hit.item.properties[k];
          });
          props[PROP] = hit.date;
          return origFetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: hit.line, quantity: hit.item.quantity, properties: props }),
          }).then(function (r) {
            if (!r.ok) return changed;
            changed = true;
            return step(n + 1);
          });
        });
      });
    }
    return step(0);
  }

  function isAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  // The add-to-cart answer carries pre-rendered cart sections for the drawer. After stamping, swap in
  // fresh ones so the drawer the shopper sees already shows the date.
  function refreshed(res) {
    return res
      .clone()
      .json()
      .then(function (body) {
        var names = body && body.sections ? Object.keys(body.sections) : [];
        if (!names.length) return res;
        return origFetch('/?sections=' + names.join(','), { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (fresh) {
            names.forEach(function (name) {
              if (fresh && fresh[name]) body.sections[name] = fresh[name];
            });
            return new Response(JSON.stringify(body), {
              status: res.status,
              statusText: res.statusText,
              headers: res.headers,
            });
          });
      })
      .catch(function () {
        return res;
      });
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (!isAdd(url)) return p;
    return p.then(function (res) {
      if (!res.ok) return res;
      return fixCart()
        .then(function (changed) {
          return changed ? refreshed(res) : res;
        })
        .catch(function () {
          return res;
        });
    });
  };

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    var viewport = document.querySelector('.layout--viewport');
    var empty = viewport && viewport.getAttribute('data-cart-empty') === 'true';
    if (!empty) {
      fixCart()
        .then(function (changed) {
          // The cart on screen was drawn before the fix, so redraw once. The next load has nothing to fix.
          if (changed && !sessionStorage.getItem('bes-preorder-reloaded')) {
            sessionStorage.setItem('bes-preorder-reloaded', '1');
            location.reload();
          } else if (!changed) {
            sessionStorage.removeItem('bes-preorder-reloaded');
          }
        })
        .catch(function () {});
    }

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.getAttribute || form.__besChecked) return;
        var action = form.getAttribute('action') || '';
        if (!/^\/cart(\?|$)/.test(action) && !/\/cart$/.test(action)) return;
        e.preventDefault();
        var submitter = e.submitter;
        fixCart()
          .catch(function () {})
          .then(function () {
            form.__besChecked = true;
            if (form.requestSubmit) form.requestSubmit(submitter || undefined);
            else form.submit();
          });
      },
      true
    );
  });
})();
